<div class="c-stepper">
	<div
		*ngFor="let STEP_NAME of STEP_NAMES; let i = index"
		class="c-stepper__item"
		[class.c-stepper__item--line]="i + 1 < STEP_NAMES.length"
		[class.c-stepper__item--active]="i === active"
		[class.c-stepper__item--done]="i < active"
		(click)="goToClick(i)"
	>
		<div class="c-stepper__item__dot">
			<tvcore-icon name="checkmark"></tvcore-icon>
		</div>

		<span>{{ STEP_NAME }}</span>
	</div>
</div>

<h2 class="u-title u-m-top--md">{{ STEP_LABEL }} {{ active + 1 }}: {{ STEP_NAMES[active] }}</h2>

<p *ngIf="subtitle" class="u-m-top--xxs">{{ subtitle }}</p>

<hr class="u-m-top--sm u-m-bottom--md" />

<ng-content></ng-content>

<hr class="u-m-top--md u-m-bottom--md" />

<div class="flex-row flex--space">
	<button *ngIf="active === 0 && PREVIOUS_LABEL_ON_START" class="c-btn c-btn--secundary" (click)="previousClick(true)">{{ PREVIOUS_LABEL_ON_START }}</button>
	<button *ngIf="active > 0" class="c-btn c-btn--secundary" (click)="previousClick()">{{ PREVIOUS_LABEL }}</button>

	<div></div>

	<button *ngIf="active < STEP_NAMES.length - 1; else finishButton" class="c-btn" (click)="nextClick()">{{ NEXT_LABEL }}</button>
	<ng-template #finishButton>
		<button class="c-btn" (click)="finishClick()">{{ FINISH_LABEL || NEXT_LABEL }}</button>
	</ng-template>
</div>
